((global) => {
  function collectUpdates(form) {
    const updates = {};
    form.querySelectorAll('input[data-cart-line-key]').forEach((input) => { updates[input.dataset.cartLineKey] = Math.max(0, Number(input.value || 0)); });
    return updates;
  }

  function setBusy(form, busy) {
    form.setAttribute('aria-busy', String(busy));
    form.querySelectorAll('button,input').forEach((control) => {
      if (busy) {
        control.dataset.cartDisabledBefore = String(control.disabled);
        control.disabled = true;
      } else if (control.dataset.cartDisabledBefore !== undefined) {
        control.disabled = control.dataset.cartDisabledBefore === 'true';
        delete control.dataset.cartDisabledBefore;
      }
    });
  }

  function showError(form, message) {
    const region = form.querySelector('[data-cart-page-error]');
    if (!region) return;
    region.hidden = !message;
    const copy = region.querySelector('[data-cart-page-error-copy]');
    if (copy) copy.textContent = message || '';
  }

  async function requestJson(fetcher, url, body) {
    const response = await fetcher(url, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to update the cart.');
    return data;
  }

  global.MoveCalmlyCartPage = Object.freeze({ collectUpdates, requestJson, setBusy, showError });
})(window);
